import { produce } from "immer";
import {
  FETCH_CARE_ROUND,
  FETCH_CARE_ROUND_SUCCESS,
  FETCH_CARE_ROUND_FAILURE,
  ADD_CARE_ROUND,
  ADD_CARE_ROUND_SUCCESS,
  ADD_CARE_ROUND_FAILURE,
  FETCH_CARE_ROUND_ITEM,
  FETCH_CARE_ROUND_ITEM_SUCCESS,
  FETCH_CARE_ROUND_ITEM_FAILURE,
  EDIT_CARE_ROUND,
  EDIT_CARE_ROUND_SUCCESS,
  EDIT_CARE_ROUND_FAILURE,
  DELETE_CARE_ROUND,
  DELETE_CARE_ROUND_SUCCESS,
  DELETE_CARE_ROUND_FAILURE,
  SET_CARE_ROUND_ADD_EDIT_MODAL,
} from "./constants";

export const initialState = {
  careRoundList: [],
  currentCareRound: null,
  careRoundTotal: 0,
  isFetchingCareRound: false,
  isSubmittingCareRound: false,
  isDeletingCareRound: false,
  careRoundAddEditModal: { open: false, isEditing: false, item: null },
};

const CareRoundReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_ROUND: {
        draft.isFetchingCareRound = true;
        const page = action.payload?.page;
        if (page === 1 || page == null) {
          draft.careRoundList = [];
        }
        break;
      }
      case FETCH_CARE_ROUND_SUCCESS: {
        draft.isFetchingCareRound = false;
        const payload = action.payload;
        const p = payload?.current_page ?? 1;
        if (p === 1) {
          draft.careRoundList = payload;
        } else {
          const prevData = Array.isArray(draft.careRoundList?.data)
            ? draft.careRoundList.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.careRoundList = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: p,
          };
        }
        draft.careRoundTotal = payload?.total ?? draft.careRoundTotal ?? 0;
        break;
      }
      case FETCH_CARE_ROUND_FAILURE:
        draft.isFetchingCareRound = false;
        draft.careRoundList = [];
        break;

      case ADD_CARE_ROUND:
        draft.isSubmittingCareRound = true;
        break;
      case ADD_CARE_ROUND_SUCCESS:
        draft.isSubmittingCareRound = false;
        break;
      case ADD_CARE_ROUND_FAILURE:
        draft.isSubmittingCareRound = false;
        break;

      case FETCH_CARE_ROUND_ITEM:
        draft.isFetchingCareRound = true;
        draft.currentCareRound = null;
        break;
      case FETCH_CARE_ROUND_ITEM_SUCCESS:
        draft.isFetchingCareRound = false;
        draft.currentCareRound = action.payload;
        break;
      case FETCH_CARE_ROUND_ITEM_FAILURE:
        draft.isFetchingCareRound = false;
        draft.currentCareRound = null;
        break;

      case EDIT_CARE_ROUND:
        draft.isSubmittingCareRound = true;
        break;
      case EDIT_CARE_ROUND_SUCCESS:
        draft.isSubmittingCareRound = false;
        break;
      case EDIT_CARE_ROUND_FAILURE:
        draft.isSubmittingCareRound = false;
        break;

      case DELETE_CARE_ROUND:
        draft.isDeletingCareRound = true;
        break;
      case DELETE_CARE_ROUND_SUCCESS:
        draft.isDeletingCareRound = false;
        break;
      case DELETE_CARE_ROUND_FAILURE:
        draft.isDeletingCareRound = false;
        break;

      case SET_CARE_ROUND_ADD_EDIT_MODAL:
        draft.careRoundAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          item: action.payload?.item ?? null,
        };
        break;

      default:
        break;
    }
  });

export default CareRoundReducer;
